import axios from 'axios';
import getUrl from 'utils/getUrl';
import { generateApiError } from './utils/apiErrorMessages';

const deleteSection = (collectionPath, entityId, { section }) =>
  axios
    .post(getUrl.apiV2(`${collectionPath}/${entityId}/section/clear`), {
      section,
    })
    .catch(generateApiError());

export default deleteSection;
